import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AdvancedRestaurantWebsite from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AdvancedRestaurantWebsite />
  </React.StrictMode>
);